/**
 * Created by Sergii on 20.05.2019.
 */
import { connect } from 'react-redux';
import * as actions from '../actions/index';
import {MessageBox} from "@common/components/MessageBox.jsx";

const mapStateToProps = state => {
    return {
        type: state.messageBox.type,
        header: state.messageBox.header,
        text: state.messageBox.text,
        show: state.messageBox.show,
        confirmText: state.messageBox.confirmText,
        cancelText: state.messageBox.cancelText,
        size: state.messageBox.size,
        data: state.messageBox.data,
        showInput: state.messageBox.showInput
    }
};

const mapDispatchToProps = (dispatch, ownProps) => {
    return {
        hideMessageBox: () => dispatch(actions.showMessageBox(false)),
        onCustomOk: (type, data) => dispatch(actions.messageBoxConfirmed(type, data)),
        onInputValueChange: (value) => dispatch(actions.messageBoxInputValueChanged(value))
    }
};

const PatientLookupMessageBoxController = connect(
    mapStateToProps,
    mapDispatchToProps
)(MessageBox);

export default PatientLookupMessageBoxController;
